
import DefaultHeader from "../CommonUtils/DefaultHeader";
import LandingPageHeader from "./LandingPageHeader";
import ConversationList from "./ConversationList";
import React, { Component } from "react";
import '../LandingPage/LandingPageStyleSheet.css';
import xmppService from '../Services/XMPPService';
import HWLog from "../HWLibrary/HWLog";
import HWUser from "../HWLibrary/HWUser";
import { getUserLocation } from "../HWLibrary/HWUtils";

class LandingPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            agentsList: [],
            sessionsList: [],
            healthPings: {},
            areAllPreviousSessionsClosed: false
        }
    }

    render() {
        return (
            <>
                <div className="s360-conversation-list-view-container" >
                    <DefaultHeader {...this.props} {...this.state} />
                    <LandingPageHeader {...this.props} {...this.state} />
                    <div style={{ height: "100%", overflowY: "auto" }} >
                        <ConversationList {...this.props} {...this.state} onScrollToBottom={this.onConversationScrollToBottom} landingPageActions={this.landingPageActions} />
                    </div>
                </div>
            </>
        )
    }

    componentDidMount() {
       if (HWUser.isLoggedIn()) { // Logged in as part of form initial form.
          this.configure();
       }
    }

    // Should be called after login.
    configure = () => {
        if (!HWUser.isLoggedIn()) { return }
        xmppService.configure(this.onXMPPMessage)
        .then(() => { return xmppService.fetchAgents(15); })
        .then(() => { return this.fetchConversations(); })
        .then(() => { return this.sendCurrentUserLocation(); })
        // .then(() => { return this.fetchHealthPings();     })
        .catch(error => {
            // console.log(error);
            HWLog.error(error, "componentDidMount: Error: ");
        })
    }

    landingPageActions = {
        startNewConversation: () => { this.startNewConversation(); }
    }

    doMoveToNewConversation = false;
    startNewConversation = () => {
        this.doMoveToNewConversation = true;
        xmppService.createSession().catch(error => { HWLog.error(error, "New Conversation Error: "); this.doMoveToNewConversation = false; return error; });
    }

    fetchConversations = (lastFetchedSession) => {
        return xmppService.fetchConversations(30, lastFetchedSession);
            // .catch(error => { HWLog.error(error, "Fetch Conversations Error: "); return error; });
    }

    fetchHealthPings = () => {
        return xmppService.fetchHealthPing("7958")
            .catch(error => { HWLog.error(error, "Fetch Health Error: "); return error; });
    }

    onXMPPMessage = (message) => {
        if (!message) return;
        //  To add more cases, change it in XMPPService class.  
        switch (message.command) {
            case "GET_AGENTS_RESPONSE": this.onAgentListResponse(message); break;
            case "GET_SESSIONS_RESPONSE": this.onSessionsListResponse(message); break;
            case "CREATE_SESSION": this.onCreateSessionResponse(message); break;
            //   case "PING_RESPONSE":         this.parseAgentStatusPingResponse(message); break;
            default: break;
        }
    }

    // Parse Agents List Response.
    onAgentListResponse = (message) => {
        HWLog.info("PARSED AGENTS LIST MESSAGES", message);
        if (!message.listAgentInfo || message.listAgentInfo.length === 0) { HWLog.info("EMPTY AGENTS LIST"); return; }
        this.setState({ agentsList: message.listAgentInfo });
    }

    // Parse Conversations List Response
    lastFetchedSessionListCount = 0;
    onSessionsListResponse = (message) => {
        HWLog.info("PARSED SESSIONS LIST MESSAGES", message);
        if (!message.listSessionInfo || message.listSessionInfo.length === 0) { 
            this.lastFetchedSessionListCount = 0; 
            HWLog.info("EMPTY SESSIONS LIST"); 
            this.setState({ isFetchingConversations: false }); 
            return; 
        }
        let conversations    = this.state.conversations || [];
        let conversationIds  = conversations.map(i => i.sessionId);
        let newConversations = message.listSessionInfo.filter(i => conversationIds.indexOf(i.sessionId) === -1);
        this.lastFetchedSessionListCount = newConversations.length;
        // console.log(newConversations)
        let firstActiveConversation = [...newConversations].find(conversation=>conversation.active)
        // console.log(firstActiveConversation)
        this.setState({ 
            conversations: this.props.config.configDetails.showPreviousSession?[...conversations, ...newConversations]:(firstActiveConversation !== null && firstActiveConversation !== undefined?[firstActiveConversation]:[]), 
            isFetchingConversations: false,
            areAllPreviousSessionsClosed: newConversations.every(conversation=> !conversation.active)
        });
    }

    onCreateSessionResponse = (newSessionResponse) => {
        if (this.doMoveToNewConversation) {
            this.props.actions.startConversation(newSessionResponse);
        }
    }

    // MARK: Health Ping, Fetch session agent helath pings,
    // fetchAgentHealthPing = (sessionId) => {
    //     if (!sessionId) { HWLog.warn("No Session Id Available To Fetch Session Agent Health Ping: "); return; }
    //     xmppService.fetchAgentHealthPing(sessionId);
    // }

    // //  GREEN - Online
    // //  RED - Offline
    // //  Yellow - Away
    // parseAgentStatusPingResponse = (message) => {
    //     let sessionId         = message.sessionId || '';
    //     let status            = message.onlineStatus && message.onlineStatus.status || '';
    //     let isValidStatus = ["GREEN","RED","Yellow"].indexOf(status) !== -1;
    //     if (!isValidStatus) { HWLog.info("Invlaid Ping Status From Server: ", message || {}); return; }

    //     let conversations    = (this.state.conversations || []).map(conversation => {
    //         if (conversation.sessionId === sessionId) {
    //             conversation.active = (status === "GREEN");
    //         }
    //         return conversation;
    //     });
    //     this.setState({conversations: conversations});
    //     HWLog.info("AGENT PING STATUS: " + status);
    //  }

    // MARK: Handle Session Pagination
    onConversationScrollToBottom = () => {
        HWLog.info("SCROLLED TO BOTTOM:" + this.lastFetchedSessionListCount);
        if (this.lastFetchedSessionListCount === 0) {
            return;
        }
        this.fetchNextPageConversations();
    }
    
    fetchNextPageConversations = () => {
        if (this.state.isFetchingConversations) { return; }
        let conversations = (this.state.conversations || []);
        if (conversations.length === 0) { return }
        let lastConversation = conversations[conversations.length-1];
        this.setState({isFetchingConversations: true}, () => {
            this.fetchConversations(lastConversation).catch(error => { this.setState({ isFetchingConversations: false }); });
        })
    }

    // MARK: User Location
    sendCurrentUserLocation = () => {
        HWLog.info("GETTING USER LOCATION:");
        getUserLocation().then(result => {
            if (result && result.coords && result.coords.latitude && result.coords.longitude) {
                xmppService.sendUserLocation(result.coords.latitude, result.coords.longitude);
            } else {
                HWLog.warn("Invalid Location Result:");
            }
        }).catch(error => { HWLog.warn("Could Not Get User Location:", error); });
    }
}

export default LandingPage;